module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("BLUE YODEL 10")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-subtitle1"
  }, [_c('span', [_vm._v("ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Marisa rejects being expected to “do for” men. So she does for plants")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("We have eighty-four plants. Marisa talks to them, and they nod…")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("We have the only apartment I know of that has to be raked")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47100f06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter19.vue
// module id = 141
// module chunks = 0